module.exports = __webpack_public_path__ + "b42d284016002437c3ecee199b5f1321.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-6.png
// module id = 3110
// module chunks = 0